<h2 mat-dialog-title class="dialog-title">
  <div class="title-icon">
    <mat-icon>person_add</mat-icon>
  </div>
  <div class="title-text">
    <span class="title-main">Invite User</span>
    <span class="title-sub">
      {{ data.isPlatformAdmin ? 'Platform administration' : 'Tenant administration' }}
    </span>
  </div>
</h2>


<mat-dialog-content [formGroup]="form">

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Email</mat-label>
    <input matInput formControlName="email">
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Full Name</mat-label>
    <input matInput formControlName="full_name">
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Role</mat-label>
    <mat-select formControlName="role">
      <mat-option value="admin">Admin</mat-option>
      <mat-option value="user">User</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field
    *ngIf="data.isPlatformAdmin"
    appearance="outline"
    class="full-width">
    <mat-label>Tenant</mat-label>
    <mat-select formControlName="tenant_id">
      <mat-option *ngFor="let t of data.tenantOptions" [value]="t">
        {{ t }}
      </mat-option>
    </mat-select>
  </mat-form-field>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="submit()">Invite</button>
</mat-dialog-actions>
